// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"tY-z","inlineTitle":"uY-z","sponsoredAdsWrapper":"vY-z","marketplaceRecosWrapper":"wY-z"};